import Vuex, { ActionContext } from "vuex";
import Vue from "vue";

Vue.use(Vuex);

import { SwatchAppState, UiAppState, PageConfig } from "../types";
import { uiMutations, appMutations } from "./mutations";
import { uiActions, appActions } from "./actions";

const appState: SwatchAppState = {
  selectedEc: null,
  ecList: [],
  loggedInUser: {
    id: null,
    name: null,
    email: null,
    display_name: null,
    phone: null,
    image_url: null,
    city: null,
    hasWriteAccess: false
  },
  productSearchResultsTable: {
    data: [],
    pageConfig: PageConfig
  },
  searchedProductSelected: null,
  breadcrumb: {
    items: [],
    routeActive: ""
  },
  inventoryProductSearchResult: {
    data: [],
    pageConfig: PageConfig
  },
  inventorySkuDetails: {
    data: [],
    pageConfig: PageConfig
  },
  inventorySampleDetails: {
    data: [],
    pageConfig: PageConfig
  },
  lendingHistoryDetails: {
    data: [],
    pageConfig: PageConfig
  },
  analyticsInstance: null,
  config: null,
  auth: null,
};

const uiState = function(): UiAppState {
  return {
    isOnMobileDevice: false,
    modalElement: {
      isVisible: false,
      isClosable: false,
      title: "",
      type: "loading",
      content: "Loading ..."
    },
    toastsList: []
  };
};

export type StateContext<T> = ActionContext<
  T,
  { uiModule: UiAppState; appModule: SwatchAppState }
>;

export default new Vuex.Store<{
  appModule: SwatchAppState;
  uiModule: UiAppState;
}>({
  modules: {
    appModule: {
      state: appState,
      namespaced: true,
      mutations: appMutations,
      actions: appActions
    },
    uiModule: {
      state: uiState(),
      namespaced: true,
      mutations: uiMutations,
      actions: uiActions
    }
  }
});
